import { Box } from "@/components/ui/box"
import { HStack } from "@/components/ui/hstack"
import { Text } from "@/components/ui/text"
import { VStack } from "@/components/ui/vstack"
import { Colors } from "@/constants/Colors"
import { ContactSkillHistoryPoint } from "@/data/prooftree"

export function InteractionTimeline({
  history,
  color,
  showLabels = false,
}: {
  history: ContactSkillHistoryPoint[]
  color: string
  showLabels?: boolean
}) {
  const visibleHistory = history.slice(-6)

  return (
    <VStack className="gap-2">
      <HStack className="h-16 items-end gap-1.5">
        {visibleHistory.map((point) => (
          <VStack key={point.id} className="flex-1 items-center gap-1">
            <Box
              className="w-full rounded-full"
              style={{
                height: `${Math.max(18, point.score)}%`,
                minHeight: 12,
                backgroundColor: `${color}${point.score >= 65 ? "E6" : "8F"}`,
              }}
            />
            {showLabels ? (
              <Text className="text-[10px] font-bold" style={{ color: Colors.dark.textTertiary }}>
                {point.score}
              </Text>
            ) : null}
          </VStack>
        ))}
      </HStack>
      {showLabels ? (
        <HStack className="justify-between gap-1">
          {visibleHistory.map((point) => (
            <Text
              key={point.id}
              className="text-[10px]"
              style={{ color: Colors.dark.textTertiary }}
            >
              {point.date}
            </Text>
          ))}
        </HStack>
      ) : null}
    </VStack>
  )
}
